import api from "./index";
import type { Child, Lesson, TimetableResponse } from "./types";

export const timetableApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTimetable: builder.query<TimetableResponse, { daysBack?: number; daysAhead?: number; refresh?: boolean } | void>({
      query: (args) => ({ url: "/timetable", params: { daysBack: args?.daysBack ?? 7, daysAhead: args?.daysAhead ?? 21, ...(args?.refresh ? { refresh: 1 } : {}) } }),
      providesTags: ["Timetable"],
    }),
    getLesson: builder.query<{ lesson: Lesson; children: Child[] }, number>({
      query: (registerId) => ({ url: `/timetable/lesson/${registerId}` }),
      providesTags: ["Timetable"],
    }),
  }),
});

export const { useGetTimetableQuery, useGetLessonQuery } = timetableApi;
